import script from "./SelfRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfRegister.vue?vue&type=script&setup=true&lang=js"

import "./SelfRegister.vue?vue&type=style&index=0&id=ec0eafe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec0eafe4"]])

export default __exports__